import { usePartnerVm } from "./platformViewModels.js";
import { ProvisionCard, useActionStatus } from "./ProvisionCard.js";

/** Admin: one-click Stripe Connect Express onboarding link for a tenant. */
export function ConnectOnboardPanel({ slug }: { slug: string }) {
  const status = useActionStatus();
  const vm = usePartnerVm();

  return (
    <ProvisionCard
      title="Stripe Connect"
      lead="Generate a one-click Express onboarding link. The connected account id is saved on this tenant automatically."
      status={status}
    >
      <button
        type="button"
        className="ops-btn"
        onClick={() => {
          status.start();
          const returnUrl = window.location.href;
          void vm.startConnectOnboarding(slug, returnUrl).then(
            (r) => {
              status.ok(`Account ${r.accountId} — open onboarding:`);
              window.open(r.url, "_blank", "noopener,noreferrer");
            },
            (e: unknown) => status.fail(e, "Connect onboarding failed"),
          );
        }}
      >
        Create Connect onboarding link
      </button>
    </ProvisionCard>
  );
}
